import React from "react";

import TeamMemberSection from "./TeamMemberSection";
import SeniorExecutiveTeamAnimation from "./SeniorExecutiveTeamAnimation";
import SeniorStaffChartSection from "./SeniorStaffChart";

const ExecutiveTeam = () => {
  return (
    <div>

      <div className="">
        <SeniorExecutiveTeamAnimation />

        <div className="flex items-center justify-center w-full py-24 bg-sdorange bg-opacity-15">
          <p className="max-w-2xl text-center text-2xl font-bold font-serif">
            Meet the members of the Senior Executive Team.
          </p>
        </div>

        <div className="flex justify-center items-center -gap-4 -py-14">
        </div>

        <TeamMemberSection />
        <SeniorStaffChartSection />
      </div>
    </div>
  );
};

export default ExecutiveTeam;
